export default function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/ascending.js
// module id = 19
// module chunks = 0 1 2 3 4